import { useCallback, useEffect, useRef } from 'react'

export const useMouseParallax = () => {
  const ref = useRef<HTMLDivElement>(null)

  const handleMouseMove = useCallback((e: MouseEvent) => {
    if (!ref.current) return
    const rect = ref.current.getBoundingClientRect()
    const x = ((e.clientX - rect.left) / rect.width - 0.5) * 2
    const y = ((e.clientY - rect.top) / rect.height - 0.5) * 2
    ref.current.style.setProperty('--mouse-x', String(x))
    ref.current.style.setProperty('--mouse-y', String(y))
  }, [])

  const handleMouseLeave = useCallback(() => {
    ref.current?.style.setProperty('--mouse-x', '0')
    ref.current?.style.setProperty('--mouse-y', '0')
  }, [])

  useEffect(() => {
    const el = ref.current
    if (!el) return

    el.addEventListener('mousemove', handleMouseMove)
    el.addEventListener('mouseleave', handleMouseLeave)

    return () => {
      el.removeEventListener('mousemove', handleMouseMove)
      el.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [handleMouseMove, handleMouseLeave])

  return ref
}
